import { Link } from 'react-router-dom'

import { Badge } from '@tribeplatform/react-ui-kit/Badge'

type TagPillProps = {
  title: string
  active?: boolean
  className?: string
}

type TagPillWithLinkProps = TagPillProps & {
  link: string | (() => string)
  title: string
}

export const TagPill = ({ title, active, className }: TagPillProps) => (
  <Badge
    rounded
    size="lg"
    variant={active ? 'primary' : 'secondary'}
    className={className}
  >
    {title}
  </Badge>
)

// eslint-disable-next-line @typescript-eslint/ban-types
export function isFunction<T extends Function = Function>(
  value: any,
): value is T {
  return typeof value === 'function'
}

export const TagPillWithLink = ({
  link,
  className,
  ...pillProps
}: TagPillWithLinkProps) => {
  let to = ''
  if (isFunction(link)) {
    to = link()
  } else {
    to = link
  }
  return (
    <Link to={to} className={className}>
      <TagPill {...pillProps} />
    </Link>
  )
}
